import { Image, Page, Text, View } from "@react-pdf/renderer";
import config from "../../../../config";
import { styles } from "./physicalComponentPdfStyles";
import {
	PhysicalEntryRow,
	PhysicalPdfCompanyDetails,
	PhysicalPdfLabels,
} from "./types";

interface ShippingLabelPageProps {
	orderId: number;
	entries: PhysicalEntryRow[];
	verticals: string[];
	company: PhysicalPdfCompanyDetails;
	labels: PhysicalPdfLabels;
}

const ShippingLabelPage = ({
	orderId,
	entries,
	verticals,
	company,
	labels,
}: ShippingLabelPageProps) => {
	const shipToLines = [
		labels.physicalPdfShipToLine1,
		labels.physicalPdfShipToLine2,
		labels.physicalPdfShipToLine3,
		labels.physicalPdfShipToLine4,
		labels.physicalPdfShipToLine5,
		labels.physicalPdfShipToLine6,
		labels.physicalPdfShipToLine7,
		labels.physicalPdfShipToLine8,
		labels.physicalPdfShipToLine9,
		labels.physicalPdfShipToLine10,
	].filter(Boolean);

	return (
		<Page size="A4" style={styles.page}>
			<View
				style={{
					...styles.flexRow,
					...styles.justifyBetween,
					...styles.itemsCenter,
					...styles.mbHalf,
				}}
			>
				<Image style={styles.logo} src={config.assets.logos.localPng} />
				<View style={{ ...styles.flexCol, alignItems: "flex-end" }}>
					<Text style={styles.eyebrow}>{labels.physicalPdfPage2Title}</Text>
					<Text style={styles.orderNumber}>#{orderId}</Text>
				</View>
			</View>

			<View style={{ ...styles.divider }} />

			<Text style={styles.cutOutEyebrow}>
				{labels.physicalPdfCutOutEyebrow}
			</Text>

			<View style={styles.cutOut}>
				<View
					style={{
						...styles.flexRow,
						...styles.justifyBetween,
						...styles.itemsCenter,
						...styles.mbHalf,
					}}
				>
					<Image style={styles.logo} src={config.assets.logos.localPng} />
					<View
						style={{
							...styles.flexCol,
							...styles.serif,
							alignItems: "flex-end",
						}}
					>
						<Text style={{ ...styles.eyebrow, ...styles.smallestText }}>
							{labels.physicalPdfPage2Title}
						</Text>
						{/* <Text style={styles.orderNumber}>#{orderId}</Text> */}
					</View>
				</View>

				<View style={{ ...styles.divider }} />

				<Text style={{ ...styles.smallColumnLabel, ...styles.mbHalf }}>
					{labels.physicalPdfTableHeaderVertical}
				</Text>
				<View style={{ ...styles.flexRow, ...styles.mb1, flexWrap: "wrap" }}>
					{verticals.map((vertical) => (
						<Text
							key={vertical}
							style={{ ...styles.bodyText, marginRight: 16 }}
						>
							{vertical}
						</Text>
					))}
				</View>

				<View style={styles.divider} />

				<View style={{ ...styles.flexRow, ...styles.mb1 }}>
					<View style={styles.addressBlock}>
						<Text style={{ ...styles.smallColumnLabel, ...styles.mbHalf }}>
							{labels.physicalPdfFromLabel}
						</Text>
						<Text style={{ ...styles.shipToName }}>
							{company.entryContactName || company.companyName}
						</Text>
						<Text style={styles.bodyText}>{company.fromAddress}</Text>
					</View>
					<View style={styles.addressBlock}>
						<Text style={{ ...styles.smallColumnLabel, ...styles.mbHalf }}>
							{labels.physicalPdfShipToLabel}
						</Text>
						<Text style={styles.shipToName}>
							{labels.physicalPdfShipToName}
						</Text>
						{shipToLines.map((line, index) => (
							<Text key={index} style={styles.bodyText}>
								{line}
							</Text>
						))}
					</View>
				</View>

				<View style={styles.divider} />

				<Text
					style={{
						...styles.mbHalf,
						...styles.smallestText,
						...styles.mutedText,
						textAlign: "center",
					}}
				>
					{labels.physicalPdfCheckAsPackedLabel}
				</Text>

				<View style={styles.tableHeaderRow}>
					<View style={styles.colCheck} />
					<View style={styles.colEntry}>
						<Text style={styles.tableHeaderText}>
							{labels.physicalPdfTableHeaderEntry}
						</Text>
					</View>
					<View style={styles.colAward}>
						<Text style={styles.tableHeaderText}>
							{labels.physicalPdfTableHeaderAwardShow}
						</Text>
					</View>
					<View style={styles.colProgram}>
						<Text style={styles.tableHeaderText}>
							{labels.physicalPdfTableHeaderIndustry}
						</Text>
					</View>
					<View style={styles.colCategory}>
						<Text style={styles.tableHeaderText}>
							{labels.physicalPdfTableHeaderCategory}
						</Text>
					</View>
				</View>

				{entries.map((entry) => (
					<View key={entry.id} style={styles.tableRow} wrap={false}>
						<View
							style={{
								...styles.colCheck,
								...styles.flexRow,
								...styles.itemsCenter,
							}}
						>
							<View style={styles.checkBox} />
						</View>
						<View style={styles.colEntry}>
							<Text>{entry.id}</Text>
						</View>
						<View style={styles.colAward}>
							<Text>{entry.vertical}</Text>
						</View>
						<View style={styles.colProgram}>
							<Text>{entry.program}</Text>
						</View>
						<View style={styles.colCategory}>
							<Text>{entry.category}</Text>
						</View>
					</View>
				))}

				<View style={styles.footerRow}>
					<View
						style={{ ...styles.flexRow, ...styles.itemsCenter, gap: "4pt" }}
					>
						<Text
							style={{
								...styles.labelText,
								...styles.smallestText,
								...styles.sans,
							}}
						>
							{labels.physicalPdfOrderIdFooterLabel}
						</Text>
						<Text style={{ fontWeight: 700 }}>{orderId}</Text>
					</View>
					<View style={styles.footerEnclosedGroup}>
						<Text style={styles.footerEnclosedLabel}>
							{labels.physicalPdfEntriesEnclosedLabel}
						</Text>
						<View style={styles.enclosedCheckBox} />
					</View>
				</View>
			</View>
		</Page>
	);
};

export default ShippingLabelPage;
